(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.smoothScroll = {
    attach: function (context, settings) {
      once("smoothScroll", "body", context).forEach(function (element) {
        $(".smooth-scroll").on("click", function (event) {
          event.preventDefault();

          var target = $(this.hash);

          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
          );
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
